import { Box, Card, Group, LoadingOverlay } from "@mantine/core";
import useGetConvites from "@/components/app-container/useGetConvites";
import useQueryProjetos from "@/modules/diagnosticos-empresa/components/diagnostico-list/useQueryProjetos";
import VisualizarResultadoItem from "../visualizarResultados-item";

// prettier-ignore
// eslint-disable-next-line complexity
const VisualizarResultadosList = () => {
  const { data } = useGetConvites();
  const { data: projetosOrigem, isFetching } = useQueryProjetos(data && data[0] && data[0].idEmpresa || "");
  const projetos = projetosOrigem?.map(p => ({
    ...p,
    idEmpresaProjeto: data ? data[0]?.idEmpresa : "",
    idEmpresa: data ? data[0]?.idEmpresaColaboradorConvidado : "",
  })) as Array<TProjeto & { idEmpresa: string, idEmpresaProjeto: string }>;
  const formatProjeto = projetos?.filter(item => (item && item?.id) === (data && data[0]?.idProjeto)) as Array<TProjeto & { idEmpresa: string, idEmpresaProjeto: string }>;
  if (isFetching) {
    return (
      <Box pos="relative">
        <LoadingOverlay visible={isFetching} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }} />
      </Box>
    );
  }
  return (
    <Card withBorder shadow="md" style={{ flex: 1, overflow: "auto" }} p={0}>
      <div style={{ padding: 16 }}>
        {formatProjeto && formatProjeto?.length > 0 ?
          formatProjeto?.map((projeto) => <VisualizarResultadoItem key={projeto.id} projeto={projeto} />) : <Group justify={"center"} mt="20px">
            {/* <Text>Nenhum projeto !</Text> */}
          </Group>}
      </div>
    </Card>
  );
};

export default VisualizarResultadosList;
